import styled from "styled-components";

const ReceiptPanelStyled = styled.div`

`;

export default ReceiptPanelStyled;